<template>
  <div class="search-home">
      <div class="logo">
        <div class="logo_left">
          <img src="../../assets/jpg/srkenvue2.png" alt />
        </div>
      </div>

    <div class="headerTop">
      <div class="div1">
        <span class="span1" :class="{active: activeIndex === 1}" @click="getLog(1)">系统用户明细</span>
        <span class="span1" :class="{active: activeIndex === 2}" @click="getLog(2)">访问日志明细</span>
      </div>
      <div class="div2">
        <span class="v2_span1" v-show="activeIndex === 2" >
           <span class="filter-label">From</span>
            <po-time-picker style="width: 200px; cursor: pointer;"
              :propdata="select_1"
              @changeconfirm="
                [
                  (select_1.text = $event.text),
                  (select_1.value = $event.value),
                  (select_1.showPicker = false),
                  getAllRequestData()
                ]
              "
              @changeshowPicker="pickShow($event)"
            >
            </po-time-picker>
             <span class="filter-label">To</span>
            <po-time-picker style="width: 200px; cursor: pointer;"
                :propdata="select_2"
                @changeconfirm="
                  [
                    (select_2.text = $event.text),
                    (select_2.value = $event.value),
                    (select_2.showPicker = false),
                    getAllRequestData()
                  ]
                "
                @changeshowPicker="pickShow2($event)"
              >
            </po-time-picker>
        </span>
        <!-- <span class="v2_span2" style="border: 0px solid #ccc; align-items: center;">
          <span class="filter-label" style="padding-top: 0;width: 100px;">用户名称:</span>
          <el-input v-model="username" placeholder="请输入用户名称" style="height: 50px;"></el-input>
        </span> -->
        <span class="v2_span1" v-show="activeIndex === 2" style="padding-right: 40px;">
          <!-- <span class="filter-label">to</span>
          <po-time-picker
              :propdata="select_2"
              @changeconfirm="
                [
                  (select_2.text = $event.text),
                  (select_2.value = $event.value),
                  (select_2.showPicker = false),
                  getAllRequestData()
                ]
              "
              @changeshowPicker="pickShow2($event)"
            >
              <i class="iconfont icon-calendar" slot="prefix"></i>
            </po-time-picker> -->
        </span>
      </div>
    </div>
    <div class="table" >
       <potablepage :tableheight="420" :data="viewdata" :total="total"  :column="viewcolumn" :header-cell-style="headerCellStyle" :rowStyle="rowStyle" :PageNo="temppageNo" :pageSize="temppageSize" @handleCurrentChange="handleCurrentChange">
         <template slot="header" slot-scope="scope">
          <span class="table-label">{{scope.header.item.label}}</span>
        </template>
        <template slot="default" slot-scope="scope">
          <p class="table-label">{{ scope.default.row[scope.default.item.prop] }}</p>
        </template>
      </potablepage> 
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import moment from "moment";
import { formatDate } from "@/utils/SetFormat";
import poTimePicker from "./po-time-picker.vue";
import potablepage from "./po-tablepage.vue";
import qs from "qs";


export default {
  data() {
    return {
      cliHeight: 0,
      show: false,
      activeIndex:1,
      select_1: {},
      select_2: {},
      viewdata: [],
      total:0,
      temppageSize:10,
      temppageNo:1,
    };
  },
  components: {
    poTimePicker,
    potablepage
  },
  watch: {
    activeIndex(val) {
      this.temppageSize = 10,
      this.temppageNo=1,
      this.getAllRequestData();
    }
  },
  computed: {
    setTime() {
      const defaults = `${formatDate(new Date()).myyear}${
        formatDate(new Date()).mymonth
      }`;
       
      const data = defaults 
      const year = `${data.substr(0, 4)}`;
      const month = `${data.substr(4, 2)}`;
      return {
        text: `${year}-${month}`,
        value: new Date(`${year}-${month}`), //设置默认时间
      };
    },
     // 设置后传参数
    SetParameter() {
      return {
        BeginMonth: this.activeIndex== 1 ? null : this.select_1.text,  
        EndMonth: this.activeIndex== 1 ? null : this.select_2.text,  
        PageNo:this.temppageNo,
        PageSize:this.temppageSize
      };
    },
    viewcolumn() {

        //用户明细
      let detailUser = [
        {
          label: "WWID",
          prop: "WWID"
        }, 
        {
          label: "User Name",
          prop: "user_Name"
        }, 
        {
          label: "Email",
          prop: "email"
        },
       
        {
          label: "Company Name",
          prop: "company_Name"
        }, 
        {
          label: "Access",
          prop: "access"
        }, 
        {
          label: "Create Date",
          prop: "create_Date"
        }, 
        {
          label: "Update Date",
          prop: "update_Date"
        }
      ]

      //日志明细
      let detailLog = [
        {
          label: "WWID",
          prop: "WWID"
        }, {
          label: "User ID",
          prop: "userId"
        }, {
          label: "User Name",
          prop: "userName"
        }, {
          label: "Menu",
          prop: "menu"
        }, {
          label: "Operation Module",
          prop: "operation_Module"
        },{
          label: "Log Date",
          prop: "logDate"
        }
      ]

    

      return this.activeIndex == 1 ? detailUser : detailLog;
    },
  },
  methods: {
    getLog(val){
      this.activeIndex = val
      this.getAllRequestData();
    },
    pickShow($event) {
      this.select_1.showPicker = $event
    },
    pickShow2($event) {
      this.select_2.showPicker = $event
    },
    handleCurrentChange(val){
      this.temppageNo = val;
      this.getAllRequestData();
    },
    getAllRequestData(){

      let fromDate = moment(this.select_1.value).startOf('day');
      let endDate = moment(this.select_2.value).startOf('day');

      if (fromDate > endDate) {
        Toast('开始时间不能大于结束时间！');
        return;
      }
       

      if (this.activeIndex == 1) {
        //用户明细
          this.$addr.post("adminportal/getUserList",qs.stringify(this.SetParameter))
          .then((res) => {
            this.viewdata = res.data.dataList;
            this.total = res.data.totalCount;
          })
          .catch((error) => {
            this.$toast("接受数据失败");
          });
      }else{
          //日志明细
          this.$addr.post("adminportal/getOperationLog",qs.stringify(this.SetParameter))
          .then((res) => {
            this.viewdata = res.data.dataList;
            this.total = res.data.totalCount;
          })
          .catch((error) => {
            this.$toast("接受数据失败");
          });
      }

     
    }, 
     formatRowDate(value) {
      return  moment(value).format('YYYY-MM-DD HH:mm:ss') 
    },

    headerCellStyle() {
      return {
        height: "30px",
        background: "linear-gradient(to top, #E2E2E2 , #EFEFEF)",
        fontWeight: 700,
        color: "#222"
      };
    },
    rowStyle({ row, rowIndex }) {
      return {
        height: "40px",
        lineHeight: "40px",
        color: "#222",
        background:
          rowIndex % 2 === 0 ? "#F3F5F9" : '#fff',
      };
    },
    initMyHeight() {
      if (this.$route.path == "/adminportal") {
        $(".cover-Blink-area").remove();
      }
    }
  },
  beforeMount() {
    this.initMyHeight();
  },
  mounted() {
    this.select_1 = {
      showPicker: false,
      ...this.setTime,
      minDate: new Date(formatDate(new Date()).myyear - 1, 0, 1),
      maxDate: new Date(formatDate(new Date()).myyear, 11, 1),
      position: "bottom",
    };

   this.select_2 = {
      showPicker: false,
      ...this.setTime,
      minDate: new Date(formatDate(new Date()).myyear - 1, 0, 1),
      maxDate: new Date(formatDate(new Date()).myyear, 11, 1),
      position: "bottom",
    };
    this.getAllRequestData();
  }
};
</script>
<style scoped>
.logo{
  background: #01B198;
  height: 80px;
  padding-top: 30px;
  padding-left: 30px;

}
 .logo .logo_left img {
  width: 200px;
  margin-bottom: 0.2%;
}

/* ===== 把 Less 嵌套展开 ===== */
.headerTop {
  width: 100%;
  margin: 20px 25px 0;
}

.headerTop .div1 {
  display: flex;
  grid-row: 1/2;
  margin-bottom: 10px;
}

.headerTop .div2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.headerTop .div2 .v2_span1 {
  display: flex;
}

.headerTop .div2 .v2_span2 {
  display: flex;
}

.headerTop .span1 {
  display: block;
  padding: 0.13333rem 0.66667rem;
  text-align: center;
  border-radius: 0.4rem;
  border: 0.01333rem solid #026d5d;
  color: #026d5d;
  margin-right: 0.26667rem;
  font-size: 0.28rem;
  cursor: pointer;
}

.headerTop .active {
  background: linear-gradient(to left, #048b77, #01B198);
  font-weight: 700;
  color: #fff !important;
}

.iconfont {
  padding: 10px 20px;
  font-size: 21px;
}

.filter-label {
  font-size: 18px;
  padding-right: 10px;
  padding-left: 40px;
  display: flex;
  align-items: center;
}

.van-search {
  border-radius: 40px;
  width: 95%;
  margin: 0 auto;
  padding: 0;
  /* 原 @box-shadow 变量不再支持，这里给出示例值，按需替换 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

h3 {
  margin: 20px;
  padding: 15px 10px;
  background: #f4e5ea;
  font-size: 21px;
  color: #222;
}

.table {
  margin: 20px;
}

.table-label {
  font-size: 14px;
}

.search-home {
  position: relative;
  height: 100%;
}

.search-home .search-footer {
  position: absolute;
}



.el-pagination .el-pagination__total {
  font-size: 14px !important;
}

.van-cell::after{
  position:none!important;
}

</style>



// WEBPACK FOOTER //
// src/components/ReportLog/Index.vue